import { render, staticRenderFns } from "./Genswell.vue?vue&type=template&id=1d29210f&"
import script from "./Genswell.vue?vue&type=script&lang=js&"
export * from "./Genswell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports